import { createContext, useContext, ReactNode } from 'react';
import { useAutomatonTick } from '../hooks/useAutomatonTick';

type AutomatonAPI = ReturnType<typeof useAutomatonTick>;

const Ctx = createContext<AutomatonAPI | null>(null);

export function AutomatonProvider({ children, seed }: { children: ReactNode; seed?: string }) {
  const api = useAutomatonTick(seed);
  return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
}

export function useAutomaton(): AutomatonAPI {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useAutomaton must be used within AutomatonProvider');
  return ctx;
}
